export const MAX_LAYOUT_COLUMNS = 12;

export default MAX_LAYOUT_COLUMNS;
